<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17k1YNI/tc-custom/9781467464048.jpg?1730409709869" alt="This image is the cover for the book The Book of Lamentations, New International Commentary on the Old Testament (NICOT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of Lamentations, New International Commentary on the Old Testament (NICOT)
      </h1>
      <p class="bookDescription body article font2">
        <p>The book of Lamentations is one of the most vivid representations of grief and trauma in the Hebrew Bible. Written in the wake of the fall of Jerusalem to the Babylonian Empire, it is comprised of five poems of twenty-two stanzas each, in a manner of tight formal unity unparalleled by any other work in the Scriptures. </p><p>In this volume, widely respected Old Testament scholar John Goldingay analyzes these and other aspects of Lamentations while keeping a constant eye on the book’s meaning and use as Christian Scripture. After a thorough introduction that explores matters of background, composition, and theology, Goldingay provides an original translation of the book from the Masoretic text along with verse-by-verse commentary.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Goldingay
      </h2>
      
      <p class="authorDescription body article"><B>John Goldingay</B> is David Allan Hubbard Professor Emeritus of Old Testament at Fuller Seminary. &#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9144ff2c